<template>
  <div class="pt10">
   <div class="tool_company img-body">
     <img :src="property.cover_img?property.cover_img:'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png'">
   </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  }
};
</script>


